export default __webpack_public_path__ + "static/media/ig5.a80644ab.jpg";